import React from 'react';
import MediaQuery from 'react-responsive'
import './styles/Footer.scss'

const Footer = ({sectionCurrently, positionCurrently, setSectionCurrently, setPositionCurrently, Section, Position, responsive}) => {

  const scroll = () =>{
    return false;
  }

  const redirect = (section) => {
    const elementoDestino = document.getElementById(section);
    elementoDestino.scrollIntoView({ behavior: 'smooth' });
  }
  const handleRedirectWsp = () => {
    const url = 'https://wa.me/+17867467873';
    window.open(url, '_blank');
  };

  const handleRedirectApp = () => {
    const url = 'https://apps.apple.com/us/app/karta-app/id6502294163?l=es-MX';
    window.open(url, '_blank');
};

  const mx = "footer-section fade-in-animation-f disposition-column justify-center align-center ";
  const mm = "footer-section-m fade-in-animation-f disposition-column justify-center align-center ";

  return (
    <>
      <MediaQuery minWidth={900}>
        <footer className = { `${mx} ${scroll() ? "fade-out-animation" : ""}`}>
          <div className="first-row disposition-row justify-between align-center">
            <div className="logo-section disposition-column justify-start align-start">
              <img src = "assets/Footer/Logo-Karta-white.png" className = "logo" alt = "Logo" onClick={() => redirect(Section.Section1)}></img>
            </div>
            <div className="qr-section disposition-row justify-around align-center">  
              <img src = "assets/Footer/QR.png" className = "qr-img" alt = "QR"></img>        
              <div className="disposition-column justify-start align-start">
                <p className = "text-1">Download the Karta App</p>
                <p className = "text-2">Scan for download</p>
              </div>
            </div>          
          </div>
          
          <div className="second-row disposition-row justify-start align-start">
            <div className="second-row-elements disposition-row justify-between align-start">
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">For you</p>
                <p className = "text-2 link" onClick={() => redirect("section-3")}>Lowest fees</p>
                <p className = "text-2 link" onClick={() => redirect("section-5")}>Credit limit</p>
                <p className = "text-2 link" onClick={() => redirect("section-7")}>Card benefits</p>
              </div> 
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">Karta</p>
                <p className = "text-2 link" onClick={() => redirect("section-9")}>Frequently Asked Questions</p>
              </div> 
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">Contact Us</p>
                <p className = "text-2 link" onClick={handleRedirectWsp}>+1 (786) 746-7873</p>
              </div> 
            </div>
          </div>
          <hr className = "line"></hr>
          <div className="fourth-row disposition-row justify-start align-center">
            <p className = "text-3">Karta is issued by Third National under license from VISA International. Karta is a financial technology company, not a bank. For more information, please see our Electronic Communications and User Agreement.</p>
          </div>
        </footer>
      </MediaQuery>
      <MediaQuery maxWidth={900}>
        <footer className = { `${mm} ${scroll() ? "fade-out-animation" : ""}`}>
          <div className="first-row disposition-column justify-between align-start">
            <div className="logo-section disposition-column justify-start align-start">
              <img src = "assets/Footer/Logo-Karta-white.png" className = "logo" alt = "Logo" onClick={() => redirect(Section.Section1)}></img>
            </div>
            <div className="qr-section disposition-row justify-around align-center">  
              <img src = "assets/Footer/app-store.png" className = "app-img" alt = "App" onClick = {handleRedirectApp}></img>        
            </div>          
          </div>
          <div className="second-row disposition-row justify-start align-start">
            <div className="second-row-elements disposition-column justify-between align-start">
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">For you</p>
                <p className = "text-2 link" onClick={() => redirect("section-3")}>Lowest fees</p>
                <p className = "text-2 link" onClick={() => redirect("section-5")}>Credit limit</p>
                <p className = "text-2 link" onClick={() => redirect("section-7")}>Card benefits</p>
              </div> 
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">Karta</p>
                <p className = "text-2 link" onClick={() => redirect("section-9")}>Frequently Asked Questions</p>
              </div> 
              <div className="element-column disposition-column justify-center align-start">
                <p className = "text-1">Contact Us</p>
                <p className = "text-2 link" onClick={handleRedirectWsp}>+1 (786) 746-7873</p>
              </div> 
            </div>
          </div>
          <div className="third-row disposition-row justify-start align-center">
              <div className="elements-third-row disposition-row justify-center align-center">
                <img src = "assets/Footer/language-white.png" className = "language-img" alt = "Language"></img>
                <p className = "text-1">English</p>
              </div> 
          </div>
          <hr className = "line"></hr>
          <div className="fourth-row disposition-row justify-start align-center">
            <p className = "text-3">Karta is issued by Third National under license from VISA International. Karta is a financial technology company, not a bank. For more information, please see our Electronic Communications and User Agreement.</p>
          </div>
        </footer>
      </MediaQuery>
    </>
  ); 
};

export default Footer;
